module.exports = __webpack_public_path__ + "static/logo-cll-91878240285f2adaf73212e783146104.png";